module.exports = __webpack_public_path__ + "img/Tw.689a75bf.svg";